<template>
    <a href="#top" class="stickyPfeil">
        <i class="bi bi-arrow-up-square"></i>
      </a>
</template>